import { upperCaseFirst } from 'upper-case-first';
import { reactive } from 'vue';

const storageName = 'yachtas-user';

export const userStore = reactive({
  isLogged: false,
  details: {},

  // -- Methods --

  /**
   * Synchronously initializes user state from localStorage.
   * `this` refers to the reactive userStore object.
   */
  init() {
    const storedUserJSON = localStorage.getItem(storageName);
    if (!storedUserJSON) return;

    try {
      const storedUser = JSON.parse(storedUserJSON);
      if (storedUser.email && storedUser.loginToken) {
        this.details = storedUser;
        this.isLogged = true;
      }
    } catch {
      // Malformed JSON, do nothing.
    }
  },

  /**
   * Gets the display name for the user.
   */
  getUsername(short = false) {
    if (!this.isLogged) return false;

    const username = this.details.firstName
      ? upperCaseFirst(this.details.firstName)
      : this.details.email.split('@')[0];

    const limit = 15;
    if (short && username.length > limit) {
      return `${username.slice(0, limit - 3)}...`;
    }
    return username;
  },

  // -- "Private" mutations for authService --

  _setLoggedIn(details) {
    this.details = details;
    this.isLogged = true;
    localStorage.setItem(storageName, JSON.stringify(details));
  },

  _setLoggedOut() {
    this.details = {};
    this.isLogged = false;
    localStorage.removeItem(storageName);
  },
});
